import axios from 'axios';

// Create an Axios instance
const apiClient = axios.create({
  baseURL: 'http://localhost:3000', // Replace with your backend API URL
  timeout: 10000, // Request timeout (optional)
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor to include authorization tokens (optional)
apiClient.interceptors.request.use(
  (config) => {
    // Get token from local storage or context (if you're using JWT)
    const token = localStorage.getItem('token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor to handle responses or errors globally
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Handle unauthorized access, possibly redirect to login
    }
    return Promise.reject(error);
  }
);

export default apiClient;
